export const fieldsMapPosologia = {
    ocorrenciaNo: { name: 'ocorrenciaNo', type: 'number' },
    V_34915: { name: 'codigo', type: 'number' },
    V_34916: { name: 'titulo', type: 'string' },
    V_34917: { name: 'habilitado', type: 'boolean' },
};
